.dialogTitle {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* HelpIcon nudges itself down for inline text flow; undo that so it centers in the flex row */
.dialogTitle svg {
    top: 0;
    padding-bottom: 0;
}

.contactFields {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.addContactButton {
    margin-top: 20px;
}

.contactRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
}

.contactMain {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.contactInfo {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.contactInfo > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contactActions {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

.existingContactsHeading {
    margin-top: 24px;
    margin-bottom: 12px;
}

.editForm,
.confirmDeleteForm {
    width: 100%;
}

.modalButtonRow {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    padding-top: 28px;
}
